import { useState } from 'react';

import arrow from '../../../images/right-arrow.svg';
import {
  FaqAnswer,
  FaqIcon,
  FaqItem,
  FaqList,
  FaqQuestion,
  Image,
} from '../../../styles/styles';

export function FaqAccordionList({ items }) {
  const [openQuestionId, setOpenQuestionId] = useState(null);

  const handleQuestionClick = (id) => {
    setOpenQuestionId((current) => (current === id ? null : id));
  };

  return (
    <FaqList>
      {items.map(({ id, question, answer }) => {
        const isOpen = openQuestionId === id;
        return (
          <FaqItem key={id}>
            <FaqQuestion onClick={() => handleQuestionClick(id)}>
              <span>{question}</span>
              <FaqIcon isOpen={isOpen}>
                <Image src={arrow} alt="" />
              </FaqIcon>
            </FaqQuestion>
            <FaqAnswer isOpen={isOpen}>{answer}</FaqAnswer>
          </FaqItem>
        );
      })}
    </FaqList>
  );
}
